import React from "react";
import { Col, Row } from "antd";
import { Controller } from "react-hook-form";
import ProfileForm from "../../../../../components/profile-form/profile-form";

const ContactInfo = ({ control, isEditMode }) => {
  return (
    <Row style={{ margin: "20px 0" }} gutter={[32, 16]}>
      <Col xs={24} sm={24} md={12} lg={12}>
        <Controller
          name="address"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="Full Address"
              required
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={12} lg={12}>
        <Controller
          name="phone"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              inputLabel="Phone No"
              required
              isEdit={isEditMode}
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={12} lg={12}>
        <Controller
          name="email"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.TextInput
              isEdit={isEditMode}
              inputLabel="Email"
              required
              value={field.value}
              onChange={field.onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>
    </Row>
  )
};

export default ContactInfo;